//@ts-ignore
import md5 from 'md5-hash';
//@ts-ignore
import bin2hex from 'locutus/php/strings/bin2hex';

export const formatCreditPassword = (password: string) => { 
    const hash = md5(password);
    return bin2hex(hash);
}